import { createTheme } from '@mui/material/styles';
import { ptBR } from '@mui/x-data-grid';

const theme = createTheme({
  palette: {
    mode: 'light',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
}, ptBR);

export default theme; 